export enum ButtonVariant {
    solid = 'solid',
    outline = 'outline',
}
